import { IClientSocket } from './namespaces/client';
import { TypedEnumUnion } from './namespaces';

export type ClientEvents = TypedEnumUnion<IClientSocket.ClientEventsValues>;
export const ClientEvents = { ...IClientSocket.ClientEvents };
export default ClientEvents;
